"use client";
import * as React from "react";
const SvgGumpenSymbol = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M19.9852 13.0453C20.0077 12.5668 20.0077 12.1362 19.9626 11.5674V11.5688H10.5858V14.3637H16.5568C16.1027 15.9771 14.3992 17.0004 12.3557 17.0004C9.26733 17.0004 7.22386 14.8647 7.22386 12.0007C7.22386 9.13665 9.31377 7.04607 12.1061 7.04607C14.2186 7.04607 15.4667 8.13591 16.1027 9.40908H19.5762C18.7357 6.18225 16.0337 4 12.1061 4C7.42834 4 4 7.36241 4 11.9993C4 16.6362 7.38318 20 12.3557 20C16.9193 20 19.8033 16.7493 19.9852 13.0453Z", fill: "black" }));
export {
  SvgGumpenSymbol as default
};
